const TOPICS = ['ARRAY', 'DYNAMIC PROGRAMMING', 'GREEDY', 'MATRIX', 'TRIE', 'STRING', 'SEARCHING AND SORTING', 'LINKED LIST', 'BACKTRACKING', 'HEAP', 'GRAPH', 'STACKS AND QUEUES', 'BINARY TREES', 'BINARY SEARCH TREES', 'BIT MANIPULATION']

export default TOPICS;